// Dashboard
import { dashboardAgents, dashboardAgentConfig } from './dashboard.agents.js'

export default function dashboardAgentsRoutes($stateProvider) {
  'ngInject'
  $stateProvider.state(dashboardAgents, dashboardAgentConfig)
}
